/** Returns a new list with the item at `from` relocated to `to`. Out-of-range indices are a no-op. */
export const moveItem = <T,>(list: T[], from: number, to: number): T[] => {
  if (from < 0 || to < 0 || from >= list.length || to >= list.length || from === to) {
    return list
  }
  const next = list.slice()
  const [item] = next.splice(from, 1)
  next.splice(to, 0, item)
  return next
}

/** True when the two lists hold a different sequence of ids. */
export const hasOrderChanged = (a: {id: string}[], b: {id: string}[]): boolean =>
  a.length !== b.length || a.some((row, index) => row.id !== b[index]?.id)

/** Reduces rows to the id-only payload the sort endpoint expects. */
export const toSortPayload = (rows: {id: string}[]) => ({
  subsidiaryPageId: rows.map((row) => ({id: row.id})),
})
